/* assets/size-preselect.js

   Auto-preselect size by product metafield group.
   - tops_men
   - tops_women
   - bottoms_men 
   - bottoms_women
   - dresses_women
   - bras_women
   - underwear_women

  Saves preference ONLY on Add to Cart (form submit).
   Preselect works with your theme's block swatches where radio values are NOT the size text.
*/

(function () {
  const SHOP = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : 'shop';
  const LS_PREFIX = `size_pref:${SHOP}:`;

  function getSizeGroup() {
    const el = document.querySelector('[data-size-group]');
    return el ? (el.getAttribute('data-size-group') || '').trim() : '';
  }

  function getStoredSize(sizeGroup) {
    if (!sizeGroup) return null;
    try {
      return localStorage.getItem(LS_PREFIX + sizeGroup);
    } catch {
      return null;
    }
  }

  function setStoredSize(sizeGroup, value) {
    if (!sizeGroup || !value) return;
    try {
      localStorage.setItem(LS_PREFIX + sizeGroup, value);
    } catch {}
  }

  function isAvailable(el) {
    return !el.disabled && el.getAttribute('aria-disabled') !== 'true';
  }

  function getVariantIdFromForm(form) {
    const idInput = form.querySelector('input[name="id"]');
    return idInput ? (idInput.value || '').trim() : '';
  }

  function getSizeMapElement() {
    return document.querySelector('script[id^="SizePrefMap-"][type="application/json"]');
  }

  function getSizeFromVariantMap(variantId) {
    if (!variantId) return '';
    const mapEl = getSizeMapElement();
    if (!mapEl) return '';

    try {
      const data = JSON.parse(mapEl.textContent || '{}');
      const byVariantId = data && data.byVariantId ? data.byVariantId : null;
      if (!byVariantId) return '';
      const val = byVariantId[String(variantId)];
      return val ? String(val).trim() : '';
    } catch {
      return '';
    }
  }

  function findThemeSizeOptionSelectors() {

    return Array.from(document.querySelectorAll('.product-form__option-selector')).filter((el) => {
      const nameEl = el.querySelector('.product-form__option-name');
      const name = (nameEl ? nameEl.textContent : '').trim().toLowerCase();
      return name.includes('size') || name.includes('מידה');
    });
  }

  function tryApplySizeOnThemeSwatches(desired) {
    if (!desired) return false;

    const blocks = findThemeSizeOptionSelectors();
    for (const block of blocks) {
      const labels = Array.from(block.querySelectorAll('label.block-swatch__item'));
      const matchLabel = labels.find((lb) => (lb.textContent || '').trim() === desired.trim());
      if (!matchLabel) continue;

      matchLabel.click();

      const forId = matchLabel.getAttribute('for');
      if (forId) {
        const input = document.getElementById(forId);
        if (input && input.matches('input[type="radio"]') && isAvailable(input)) {
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      return true;
    }

    return false;
  }

  function findStandardSizeControls() {
    const controls = [];

    document.querySelectorAll('fieldset').forEach((fs) => {
      const legend = fs.querySelector('legend');
      const label = (legend ? legend.textContent : fs.getAttribute('aria-label') || '').trim().toLowerCase();
      if (label.includes('size') || label.includes('מידה')) controls.push(fs);
    });

    document.querySelectorAll('select').forEach((sel) => {
      const labelEl = sel.id ? document.querySelector(`label[for="${CSS.escape(sel.id)}"]`) : null;
      const label = (labelEl ? labelEl.textContent : sel.getAttribute('aria-label') || '').trim().toLowerCase();
      if (label.includes('size') || label.includes('מידה')) controls.push(sel);
    });

    return controls;
  }

  function tryApplySizeStandard(control, desired) {
    if (!desired) return false;

    if (control instanceof HTMLFieldSetElement) {
      const radios = Array.from(control.querySelectorAll('input[type="radio"]'));
      const match = radios.find((r) => (r.value || '').trim() === desired.trim() && isAvailable(r));
      if (!match) return false;

      if (!match.checked) {
        match.click();
        match.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }

    if (control instanceof HTMLSelectElement) {
      const opts = Array.from(control.options);
      const match = opts.find((o) => (o.value || '').trim() === desired.trim() && !o.disabled);
      if (!match) return false;

      if (control.value !== match.value) {
        control.value = match.value;
        control.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }

    return false;
  }

  function findProductForms() {
    const forms = [
      ...document.querySelectorAll('form.shopify-product-form[action="/cart/add"]'),
      ...document.querySelectorAll('form[is="product-form"].shopify-product-form'),
      ...document.querySelectorAll('form[id^="product-form-main-"]')
    ];
    return Array.from(new Set(forms)).filter(Boolean);
  }

  function attachSaveOnATC(sizeGroup) {
    const forms = findProductForms();

    forms.forEach((form) => {
      if (form.dataset.sizePrefBound === '1') return;
      form.dataset.sizePrefBound = '1';

      form.addEventListener('submit', () => {
        // Save on ATC submit: variantId -> size via JSON map
        const variantId = getVariantIdFromForm(form);
        const sizeValue = getSizeFromVariantMap(variantId);

        if (sizeValue) setStoredSize(sizeGroup, sizeValue);
      }, { capture: true });
    });
  }

  function init() {
    const sizeGroup = getSizeGroup();
    if (!sizeGroup) return;

    const desired = getStoredSize(sizeGroup);

    if (desired) {
      let applied = tryApplySizeOnThemeSwatches(desired);

      if (!applied) {
        applied = findStandardSizeControls().some((c) => tryApplySizeStandard(c, desired));
      }

      if (!applied) {
        setTimeout(() => {
          let appliedLater = tryApplySizeOnThemeSwatches(desired);
          if (!appliedLater) {
            findStandardSizeControls().some((c) => tryApplySizeStandard(c, desired));
          }
        }, 300);
      }
    }

    attachSaveOnATC(sizeGroup);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
